import { render, staticRenderFns } from "./ResearchContacts.vue?vue&type=template&id=1a1a3540&scoped=true&"
import script from "./ResearchContacts.vue?vue&type=script&lang=js&"
export * from "./ResearchContacts.vue?vue&type=script&lang=js&"
import style0 from "./ResearchContacts.vue?vue&type=style&index=0&id=1a1a3540&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a3540",
  null
  
)

export default component.exports